import { mapState } from 'vuex'

const i18n = {
  computed:  mapState({
    data: state =>
      state.i18n.get(state.currentLangs.code) || {},
    lang: state => state.currentLangs.code
  }),
}

export default i18n